export const segmentToTag = (segment) => {
    if (!segment || typeof segment !== "string") return "";
    return `segment_${segment.toLowerCase().replace(/\s|\/|-/g, "")}`;
};